import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem, Select } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddPolicy({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Policy</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Policy Code */}
                            <div className="control_group w_50">
                                <label htmlFor="policy-code">Policy Code</label>
                                <TextField
                                    placeholder="POL-XXX-001"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "policy-code" }}
                                />
                            </div>
                            {/* Version */}
                            <div className="control_group w_50">
                                <label htmlFor="policy-version">Version</label>
                                <TextField
                                    placeholder="1.0"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "policy-version" }}
                                />
                            </div>
                            {/* Title */}
                            <div className="control_group">
                                <label htmlFor="policy-title">Title</label>
                                <TextField
                                    placeholder="Policy Title"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "policy-title" }}
                                />
                            </div>
                            {/* Description */}
                            <div className="control_group ai_rec_btn">
                                <label htmlFor="policy-description">Description</label>
                                <TextField
                                    placeholder="Brief description of the policy..."
                                    fullWidth
                                    multiline
                                    rows={3}
                                    hiddenLabel
                                    inputProps={{ id: "policy-description" }}
                                />
                                <Button className="btn btn_primary sm"><img src="/static/images/ai_icon.svg" alt="" /> Enhance with AI</Button>
                            </div>

                        

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Create
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
